import { useState } from 'react';
import useFiltersState from '../../../../state/useFiltersState';
import ModuleFilters, { TgetFiltersList } from '../../../../components/ModuleFilters/ModuleFilters';
import { getCatalogueFilters } from '../../../../services/cataloge';
import useCatalogueState from '../../../../state/useCatalogueState';
import './CatalogueFilters.scss';

const CatalogueFilters = () => {
  const { catalogueFilters, setCatalogueFilters } = useFiltersState();
  const { activeProducts } = useCatalogueState();
  const [openCategory, setOpenCategory] = useState<boolean>(false);
  const [openAvailability, setOpenAvailability] = useState<boolean>(false);
  const [openBrand, setOpenBrand] = useState<boolean>(false);
  const [openState, setOpenState] = useState<boolean>(false);
  const [openExternalLoads, setOpenExternalLoadse] = useState<boolean>(false);

  const catalogueFilterMapping = {
    Categoria: 'category',
    Marca: 'brandName',
    BuyCountry: 'country',
    Venta: 'saleStatus',
    CargueExternas: 'uploadStatus'
  };

  const getCatalogueFiltersList: TgetFiltersList = (
    formModuleFilters,
    handleClickFilterOption,
    getFilterActiveStatus
  ) => {
    const renderFilterUnlocked = getFilterActiveStatus('saleStatus');

    const activeFilters = [
      {
        title: 'Ventas',
        openFunction: setOpenState,
        openStatus: openState,
        rawSelectOptions: formModuleFilters('Venta'),
        handleChangeSelectedOption: handleClickFilterOption('saleStatus', 'name'),
        isFilterActive: getFilterActiveStatus('saleStatus')
      },
      {
        title: 'País',
        openFunction: setOpenAvailability,
        openStatus: openAvailability,
        rawSelectOptions: formModuleFilters('BuyCountry'),
        handleChangeSelectedOption: handleClickFilterOption('country', 'name'),
        isFilterActive: getFilterActiveStatus('country'),
        conditionedFilter: true,
        filterUnlocked: renderFilterUnlocked,
        aditionalInformation: 'Elige primero la venta.',
        showSearch: true,
        searchPlaceholder: 'Buscar país',
        sortAlphabetically: true
      },
      {
        title: 'Categoría',
        openFunction: setOpenCategory,
        openStatus: openCategory,
        rawSelectOptions: formModuleFilters('Categoria'),
        handleChangeSelectedOption: handleClickFilterOption('category', 'name'),
        isFilterActive: getFilterActiveStatus('category')
      },
      {
        title: 'Marca',
        openFunction: setOpenBrand,
        openStatus: openBrand,
        rawSelectOptions: formModuleFilters('Marca'),
        handleChangeSelectedOption: handleClickFilterOption('brandName', 'name'),
        isFilterActive: getFilterActiveStatus('brandName'),
        showSearch: true,
        searchPlaceholder: 'Buscar marca',
        sortAlphabetically: true
      },
      {
        title: 'Cargue externo',
        openFunction: setOpenExternalLoadse,
        openStatus: openExternalLoads,
        rawSelectOptions: formModuleFilters('CargueExternas'),
        handleChangeSelectedOption: handleClickFilterOption('uploadStatus', 'name'),
        isFilterActive: getFilterActiveStatus('uploadStatus')
      }
    ];

    const incactiveFilters = [
      {
        title: 'Categoría',
        openFunction: setOpenCategory,
        openStatus: openCategory,
        rawSelectOptions: formModuleFilters('Categoria'),
        handleChangeSelectedOption: handleClickFilterOption('category', 'name'),
        isFilterActive: getFilterActiveStatus('category')
      },
      {
        title: 'Marcas',
        openFunction: setOpenBrand,
        openStatus: openBrand,
        rawSelectOptions: formModuleFilters('Marca'),
        handleChangeSelectedOption: handleClickFilterOption('brandName', 'name'),
        isFilterActive: getFilterActiveStatus('brandName'),
        showSearch: true,
        searchPlaceholder: 'Buscar marca',
        sortAlphabetically: true
      },
      {
        title: 'País',
        openFunction: setOpenAvailability,
        openStatus: openAvailability,
        rawSelectOptions: formModuleFilters('BuyCountry'),
        handleChangeSelectedOption: handleClickFilterOption('country', 'name'),
        isFilterActive: getFilterActiveStatus('country'),
        conditionedFilter: false,
        showSearch: true,
        searchPlaceholder: 'Buscar país'
      }
    ];

    const renderFilter = activeProducts ? activeFilters : incactiveFilters;
    return renderFilter;
  };

  return (
    <div className="catalogueFilters">
      <ModuleFilters
        moduleFilters={catalogueFilters}
        setModuleFilters={setCatalogueFilters}
        getModuleFiltersRequestFunction={getCatalogueFilters}
        getFiltersList={getCatalogueFiltersList}
        moduleFiltersTitlesMapping={catalogueFilterMapping}
        customGap={40}
        countryCondition={true}
      />
    </div>
  );
};

export default CatalogueFilters;
